import React from 'react';

// Hero section: thumbnail on the LEFT, title/description/meta on the RIGHT - deliberately flipped
// vs MediaItemPage's convention (poster+quickedit column, info elsewhere) so this report page
// reads as its own distinct thing rather than a re-skinned media detail page.
const PeriodHero = ({ update, period, highlight }) => {
  // Prefer the dedicated landscape thumbnail collage generated for this specific summary over the
  // portrait poster variant - the highlight is picked for narrative reasons and isn't necessarily
  // the most visually representative image for the period.
  const posterSrc = update.image || update.poster_image || highlight?.image;
  const posterAlt = update.title;

  return (
    <div className="period-summary-hero">
      <div className="period-summary-hero-poster">
        {posterSrc ? (
          <img src={posterSrc} alt={posterAlt} />
        ) : (
          <div className="period-summary-hero-poster-placeholder">No Image</div>
        )}
      </div>
      <div className="period-summary-hero-info">
        <div className="period-summary-hero-meta">
          <span className="period-summary-hero-period-label">
            <img src="/static/icons/calendar-solid.svg" alt="" className="icon" />
            {period.label}
          </span>
          {period.is_explicit && <span className="period-summary-explicit-badge">18+</span>}
        </div>
        <h1 className="period-summary-hero-title">{update.title}</h1>
        {update.importance && (
          <div className="period-summary-hero-importance">
            <span className={`period-importance-badge period-importance-${update.importance}`}>
              {update.importance === 'big' ? '★ Big Week' : update.importance === 'medium' ? '● Active Week' : '○ Quiet Week'}
            </span>
          </div>
        )}
        <p className="period-summary-hero-description">{update.description}</p>
      </div>
    </div>
  );
};

export default PeriodHero;
